"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rule_constants_1 = require("./rule-constants");
/**
 * Check if the given condition matches a value in elementComparisonTypes.
 * @param condType The condition type to test.
 * @returns True if this condition is of the element comparison type; false otherwise
 */
function isConditionElementComparisonType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.equalElement:
        case rule_constants_1.conditionTypes.notEqualElement:
        case rule_constants_1.conditionTypes.lessThanElement:
        case rule_constants_1.conditionTypes.lessThanOrEqualElement:
        case rule_constants_1.conditionTypes.greaterThanElement:
        case rule_constants_1.conditionTypes.greaterThanOrEqualElement:
            return true;
    }
    return false;
}
exports.isConditionElementComparisonType = isConditionElementComparisonType;
/**
 * Check if the given condition matches a value in elementValueTypes.
 * @param condType The condition type to test.
 * @returns True if this condition is of the element value type; false otherwise
 */
function isConditionElementValueType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.equal:
        case rule_constants_1.conditionTypes.notEqual:
        case rule_constants_1.conditionTypes.equalLabel:
        case rule_constants_1.conditionTypes.notEqualLabel:
        case rule_constants_1.conditionTypes.equalMaskedMulti:
        case rule_constants_1.conditionTypes.notEqualMaskedMulti:
        case rule_constants_1.conditionTypes.contains:
        case rule_constants_1.conditionTypes.containsString:
        case rule_constants_1.conditionTypes.notContainString:
        case rule_constants_1.conditionTypes.lessThan:
        case rule_constants_1.conditionTypes.lessThanOrEqual:
        case rule_constants_1.conditionTypes.greaterThan:
        case rule_constants_1.conditionTypes.greaterThanOrEqual:
        case rule_constants_1.conditionTypes.beginsWith:
        case rule_constants_1.conditionTypes.notBeginWith:
        case rule_constants_1.conditionTypes.endsWith:
        case rule_constants_1.conditionTypes.notEndWith:
        case rule_constants_1.conditionTypes.matchesAny:
        case rule_constants_1.conditionTypes.notMatchAny:
        case rule_constants_1.conditionTypes.matchesAnyMaskedMulti:
        case rule_constants_1.conditionTypes.notMatchAnyMaskedMulti:
        case rule_constants_1.conditionTypes.matchesEvery:
        case rule_constants_1.conditionTypes.notMatchEvery:
        case rule_constants_1.conditionTypes.between:
        case rule_constants_1.conditionTypes.notBetween:
        case rule_constants_1.conditionTypes.last:
        case rule_constants_1.conditionTypes.notLast:
        case rule_constants_1.conditionTypes.next:
        case rule_constants_1.conditionTypes.notNext:
            return true;
    }
    return false;
}
exports.isConditionElementValueType = isConditionElementValueType;
/**
 * Check if the given condition matches a value in elementStateTypes.
 * @param condType The condition type to test.
 * @returns True if this condition is of the element state type; false otherwise
 */
function isConditionElementStateType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.empty:
        case rule_constants_1.conditionTypes.notEmpty:
        case rule_constants_1.conditionTypes.earlierThanNow:
        case rule_constants_1.conditionTypes.earlierThanNowOrEqual:
        case rule_constants_1.conditionTypes.laterThanNow:
        case rule_constants_1.conditionTypes.laterThanNowOrEqual:
        case rule_constants_1.conditionTypes.today:
        case rule_constants_1.conditionTypes.notToday:
        case rule_constants_1.conditionTypes.thisWeek:
        case rule_constants_1.conditionTypes.notThisWeek:
        case rule_constants_1.conditionTypes.thisMonth:
        case rule_constants_1.conditionTypes.notThisMonth:
        case rule_constants_1.conditionTypes.thisYear:
        case rule_constants_1.conditionTypes.notThisYear:
            return true;
    }
    return false;
}
exports.isConditionElementStateType = isConditionElementStateType;
/**
 * Check if the given condition uses operators.
 * @param condType The condition type to test.
 * @returns True if this condition is of the operator type; false otherwise
 */
function isConditionOperatorType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.operator:
            return true;
    }
    return false;
}
exports.isConditionOperatorType = isConditionOperatorType;
function isStaticConditionType(condType) {
    return condType === rule_constants_1.conditionTypes.static;
}
exports.isStaticConditionType = isStaticConditionType;
//# sourceMappingURL=rule-helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/rule-helpers.js
// module id = 1115
// module chunks = 0